// extracted by mini-css-extract-plugin
export default {"price":"t7-z","priceRow":"u7-z","onSale":"v7-z","msrpLabelPrice":"w7-z","msrpLabel":"x7-z","originalPrice":"y7-z","percentOff":"z7-z"};